var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.9168 15.2501C32.0668 9.20013 26.4335 5.7168 20.5002 5.7168C17.5335 5.7168 14.6502 6.58346 12.0168 8.20013C9.3835 9.83346 7.01683 12.2168 5.0835 15.2501C3.41683 17.8668 3.41683 22.1168 5.0835 24.7335C8.9335 30.8001 14.5668 34.2668 20.5002 34.2668C23.4668 34.2668 26.3502 33.4001 28.9835 31.7835C31.6168 30.1501 33.9835 27.7668 35.9168 24.7335C37.5835 22.1335 37.5835 17.8668 35.9168 15.2501ZM20.5002 26.7335C16.7668 26.7335 13.7668 23.7168 13.7668 20.0001C13.7668 16.2835 16.7668 13.2668 20.5002 13.2668C24.2335 13.2668 27.2335 16.2835 27.2335 20.0001C27.2335 23.7168 24.2335 26.7335 20.5002 26.7335Z",
    fill: "#FF4378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.2334C17.8833 15.2334 15.75 17.3667 15.75 20.0001C15.75 22.6167 17.8833 24.7501 20.5 24.7501C23.1167 24.7501 25.2667 22.6167 25.2667 20.0001C25.2667 17.3834 23.1167 15.2334 20.5 15.2334Z",
    fill: "#FF4378"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ea722e6ce472c8fbe3073ef240c7099c.svg";
export { ForwardRef as ReactComponent };